// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__LTzVq","sk-bouncedelay":"Spinner_sk-bouncedelay__3pBfJ","bounce1":"Spinner_bounce1__2KU6X","bounce2":"Spinner_bounce2__3TqMn"};